export default __webpack_public_path__ + "static/media/draculas-guests.54739d81.jpg";